<div class="px-2 d-flex align-items-center">
  <input type="checkbox" id="checkbox" [formControl]="control" />
  <label class="medium-gray fs-16 mx-2" for="checkbox">{{ title }}</label>
</div>
